import {
	ROUTE_DASHBOARD_BOOKINGS,
	ROUTE_DASHBOARD_BOOKING_PAGES,
	ROUTE_DASHBOARD_PARTNERS,
	ROUTE_RESOURCE_GROUPS,
	ROUTE_ROOT_PAGES_LIST
} from '@/constants/routes';
import useAuth from '@/hooks/useAuth';
import { Box, useDisclosure } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { FiCalendar, FiGrid, FiPackage, FiShare2, FiUsers } from 'react-icons/fi';
import ShellHeader from './components/shell-header.component';
import Sidebar from './components/sidebar.component';

interface IAppShellProps {}

export default function AppShell(props: PropsWithChildren<IAppShellProps>) {
	const auth = useAuth();
	const { t } = useTranslation();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const links = [
		{ text: t('Services'), icon: FiGrid, to: ROUTE_DASHBOARD_BOOKING_PAGES },
		{ text: t('Agenda'), icon: FiCalendar, to: ROUTE_DASHBOARD_BOOKINGS },
		{ text: t('Link groups'), icon: FiShare2, to: ROUTE_ROOT_PAGES_LIST },
		{ text: t('Resources'), icon: FiPackage, to: ROUTE_RESOURCE_GROUPS },
	];

	if (auth.getCurrentUser().tenant.role === 'ADMIN') {
		links.push({ text: t('Partners'), icon: FiUsers, to: ROUTE_DASHBOARD_PARTNERS });
	}

	return (
		<Box
			h="100dvh"
			w="100dvw"
			overflow="hidden"
			display="grid"
			gridTemplateColumns={{ base: '1fr', lg: 'auto 1fr' }}
			borderTopWidth={.5}
			borderTopColor="gray.200"
		>
			<Sidebar onClose={onClose} isOpen={isOpen} links={links} />
			<Box data-id="content" h="100%" w="100%" overflow="hidden" display="grid" gridTemplateRows="auto 1fr">
				<ShellHeader hideLogoInLg={true} onOpen={onOpen} />
				<Box w="full" h="full" overflow="auto">
					{props.children}
				</Box>
			</Box>
		</Box>
	);
}
